import { render, staticRenderFns } from "./GradeCurve.vue?vue&type=template&id=171d72d1&scoped=true&"
import script from "./GradeCurve.vue?vue&type=script&lang=js&"
export * from "./GradeCurve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d72d1",
  null
  
)

export default component.exports